module.exports = __webpack_public_path__ + "static/media/childcare_centre.18575ed7.jpg";